"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SixBenefits = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _hooks = require("../../hooks");
var _styles = require("../HeadlineLayout/styles");
var _Benefit = require("./Benefit");
var _BenefitsLayoutClasses = require("./BenefitsLayoutClasses");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SixBenefits = ({
  title,
  benefits,
  className,
  renderOnMyPages
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isTablet = (0, _hooks.useIsTablet)();
  const carouselOptions = (0, _react.useMemo)(() => ({
    width: '100%',
    slider: {
      loop: false,
      slides: {
        perView: 'auto',
        spacing: isTablet || renderOnMyPages ? 10 : 30
      }
    },
    pagination: {
      show: false
    },
    navigation: {
      showArrows: !isTablet,
      size: 'small',
      position: 'outside'
    }
  }), [isTablet, renderOnMyPages]);
  const rootClassName = (0, _clsx.default)(_BenefitsLayoutClasses.benefitsLayoutClasses.sixBenefitsRoot, className);
  const slides = (0, _react.useMemo)(() => {
    if (isTablet) {
      const firstThree = benefits.slice(0, 3);
      const lastThree = benefits.slice(3);
      return [firstThree, lastThree].map((chunk, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CarouselSlide
      // eslint-disable-next-line react/no-array-index-key -- no key
      , {
        minWidth: _constants.BENEFIT_WIDTH,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.SixMobileRoot, {
          "data-testid": getTestId(_constants.BENEFITS_MOBILE_SLIDE),
          children: chunk.map(benefit => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Benefit.Benefit, {
            benefit: benefit
          }, benefit?.caption))
        })
      }, `mobile-slide-${index}`));
    }
    return benefits.map(benefit => /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CarouselSlide, {
      minWidth: _constants.BENEFIT_WIDTH,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Benefit.Benefit, {
        benefit: benefit
      })
    }, benefit?.caption));
  }, [benefits, getTestId, isTablet]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Root, {
    renderOnMyPages: renderOnMyPages,
    className: rootClassName,
    "data-testid": getTestId(_constants.BENEFITS_ROOT_SIX),
    children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.LayoutHeader, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Headline, {
        "data-testid": getTestId(_constants.BENEFITS_MAIN_TITLE),
        textAlign: "center",
        variant: "h4",
        component: "h2",
        maxLines: isTablet ? 3 : 2,
        children: title
      })
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.InnerRoot, {
      isInCarousel: true,
      className: _BenefitsLayoutClasses.benefitsLayoutClasses.innerRoot,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Carousel, {
        ...carouselOptions,
        id: _constants.BENEFITS_CAROUSEL_ID,
        children: slides
      }, isTablet ? 'mobile' : 'desktop')
    })]
  });
};
exports.SixBenefits = SixBenefits;
